// action - state management
import * as actionTypes from './shopActions';

const initialState = {
    error: null,
    products: [],
    product: null,
    relatedProducts: [],
    reviews: [],
    addresses: []
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const shopReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PRODUCTS:
            return {
                ...state,
                products: action.products
            };
        case actionTypes.GET_PRODUCT:
            return {
                ...state,
                product: action.products
            };
        case actionTypes.FILTER_PRODUCTS:
            return {
                ...state,
                products: action.products
            };
        case actionTypes.GET_ADDRESSES:
            return {
                ...state,
                addresses: ['123']
            };
        default:
            return state;
    }
};

export default shopReducer;
